import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "d-flex flex-wrap align-items-center justify-content-between gap-2" }
const _hoisted_2 = { class: "row g-3 mb-25" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "pk-kpi-icon me-15" }
const _hoisted_5 = { class: "d-block fs-28 fw-bold lh-1" }
const _hoisted_6 = { class: "text-muted" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_9 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_10 = { class: "d-flex flex-wrap align-items-center gap-2 mb-20" }
const _hoisted_11 = { class: "d-flex flex-wrap align-items-center gap-2 mb-20" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["max"]
const _hoisted_14 = ["min"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "text-muted fs-12" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_19 = { class: "fs-13 mb-1" }
const _hoisted_20 = {
  class: "progress",
  style: {"height":"6px","min-width":"110px"}
}
const _hoisted_21 = {
  key: 5,
  class: "d-flex flex-column gap-1"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["disabled", "onClick"]
const _hoisted_24 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_25 = {
  key: 1,
  class: "ph ph-tag me-1"
}
const _hoisted_26 = { key: 6 }
const _hoisted_27 = {
  key: 0,
  class: "col-xl-4"
}
const _hoisted_28 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_29 = { class: "card-body p-20 p-md-25" }
const _hoisted_30 = { class: "d-flex justify-content-between align-items-start" }
const _hoisted_31 = { class: "mb-10" }
const _hoisted_32 = { class: "row mb-20 fs-14" }
const _hoisted_33 = { class: "col-7" }
const _hoisted_34 = { class: "col-7" }
const _hoisted_35 = { class: "col-7" }
const _hoisted_36 = { class: "col-7" }
const _hoisted_37 = { class: "mb-10" }
const _hoisted_38 = { class: "table table-sm" }
const _hoisted_39 = { class: "alert alert-light border fs-13" }
const _hoisted_40 = { class: "mb-10 text-danger" }
const _hoisted_41 = { class: "list-unstyled fs-13 mb-20" }
const _hoisted_42 = { class: "text-muted" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = {
  key: 1,
  class: "badge bg-success mt-1"
}
const _hoisted_45 = { class: "d-flex flex-column gap-2" }
const _hoisted_46 = { class: "d-flex gap-2" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_49 = {
  key: 1,
  class: "ph ph-printer me-1"
}
const _hoisted_50 = ["disabled"]
const _hoisted_51 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_52 = {
  key: 1,
  class: "ph ph-download-simple me-1"
}
const _hoisted_53 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BreadCrumb = _resolveComponent("BreadCrumb")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_center = _resolveComponent("center")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BreadCrumb, { PageTitle: "Préparation & emballage" }),
      (_ctx.auth.can('ADD_BL_S'))
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: { name: 'AddNoteBLStockPage' },
            class: "btn pk-btn mb-3"
          }, {
            default: _withCtx(() => _cache[11] || (_cache[11] = [
              _createElementVNode("i", { class: "ph ph-plus-circle me-1" }, null, -1),
              _createTextVNode("Créer un bon ", -1)
            ])),
            _: 1,
            __: [11]
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (t) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "col-6 col-md-3",
          key: t.key
        }, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["pk-kpi w-100 text-start border rounded-3 p-20 bg-white d-flex align-items-center", { active: _ctx.tab === t.key }]),
            onClick: ($event: any) => (_ctx.setTab(t.key))
          }, [
            _createElementVNode("span", _hoisted_4, [
              _createElementVNode("i", {
                class: _normalizeClass(t.icon)
              }, null, 2)
            ]),
            _createElementVNode("span", null, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.counts[t.key]), 1),
              _createElementVNode("span", _hoisted_6, _toDisplayString(t.label), 1)
            ])
          ], 10, _hoisted_3)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.selected ? 'col-xl-8' : 'col-12')
      }, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control shadow-none text-black rounded-0 pk-search",
                placeholder: "Rechercher un bon, une agence, un opérateur...",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.searchTerm) = $event)),
                onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSearch && _ctx.onSearch(...args)))
              }, null, 544), [
                [_vModelText, _ctx.filters.searchTerm]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[14] || (_cache[14] = _createElementVNode("span", { class: "text-muted fs-14 me-1" }, [
                _createElementVNode("i", { class: "ph ph-calendar-blank me-1" }),
                _createTextVNode("Date de création :")
              ], -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.periods, (p) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: p.key,
                  type: "button",
                  class: _normalizeClass(["btn btn-sm", _ctx.period === p.key ? 'pk-btn' : 'btn-outline-secondary']),
                  onClick: ($event: any) => (_ctx.setPeriod(p.key))
                }, _toDisplayString(p.label), 11, _hoisted_12))
              }), 128)),
              (_ctx.period === 'custom')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      class: "form-control form-control-sm pk-date",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dateFrom) = $event)),
                      max: _ctx.dateTo || undefined,
                      onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getRecords(1))),
                      "aria-label": "Du"
                    }, null, 40, _hoisted_13), [
                      [_vModelText, _ctx.dateFrom]
                    ]),
                    _cache[12] || (_cache[12] = _createElementVNode("span", { class: "text-muted" }, "→", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      class: "form-control form-control-sm pk-date",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dateTo) = $event)),
                      min: _ctx.dateFrom || undefined,
                      onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getRecords(1))),
                      "aria-label": "Au"
                    }, null, 40, _hoisted_14), [
                      [_vModelText, _ctx.dateTo]
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.hasFilters)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn btn-sm btn-link text-danger",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args)))
                  }, _cache[13] || (_cache[13] = [
                    _createElementVNode("i", { class: "ph ph-x-circle me-1" }, null, -1),
                    _createTextVNode("Réinitialiser ", -1)
                  ])))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_vue_good_table, {
              columns: _ctx.columns,
              rows: _ctx.rows,
              loading: _ctx.isLoader
            }, {
              emptystate: _withCtx(() => [
                _createVNode(_component_center, null, {
                  default: _withCtx(() => _cache[15] || (_cache[15] = [
                    _createTextVNode("Aucun bon dans cette liste", -1)
                  ])),
                  _: 1,
                  __: [15]
                })
              ]),
              "table-row": _withCtx((props) => [
                (props.column.field === 'note_stock_ref')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        class: "fw-bold",
                        onClick: ($event: any) => (_ctx.openPanel(props.row))
                      }, _toDisplayString(props.row.note_stock_ref), 9, _hoisted_15),
                      _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.getDate(props.row.created_at)), 1)
                    ], 64))
                  : (props.column.field === 'note_stock_total_parcel')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(props.row.note_stock_total_parcel) + " colis ", 1)
                      ], 64))
                    : (props.column.field === 'problems')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          (Number(props.row.problems) > 0)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: "javascript:void(0);",
                                class: "badge bg-danger text-decoration-none",
                                onClick: ($event: any) => (_ctx.openPanel(props.row))
                              }, [
                                _cache[16] || (_cache[16] = _createElementVNode("i", { class: "ph ph-warning me-1" }, null, -1)),
                                _createTextVNode(_toDisplayString(props.row.problems), 1)
                              ], 8, _hoisted_17))
                            : (_openBlock(), _createElementBlock("span", _hoisted_18, "—"))
                        ], 64))
                      : (props.column.field === 'progress')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            _createElementVNode("div", _hoisted_19, _toDisplayString(props.row.packed) + " / " + _toDisplayString(props.row.note_stock_total_parcel), 1),
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("div", {
                                class: "progress-bar pk-bar",
                                style: _normalizeStyle({ width: _ctx.percent(props.row) + '%' })
                              }, null, 4)
                            ])
                          ], 64))
                        : (props.column.field === 'packing_by_name')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                              _createTextVNode(_toDisplayString(props.row.packing_by_name || "—"), 1)
                            ], 64))
                          : (props.column.field === 'action')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                (!props.row.note_stock_delivered && Number(props.row.packed) < Number(props.row.note_stock_total_parcel))
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      class: "btn btn-sm pk-btn",
                                      to: _ctx.stationRoute(props.row)
                                    }, {
                                      default: _withCtx(() => [
                                        _cache[17] || (_cache[17] = _createElementVNode("i", { class: "ph ph-play me-1" }, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(Number(props.row.packed) > 0 ? "Reprendre" : "Démarrer l'emballage"), 1)
                                      ]),
                                      _: 2,
                                      __: [17]
                                    }, 1032, ["to"]))
                                  : (_openBlock(), _createBlock(_component_router_link, {
                                      key: 1,
                                      class: "btn btn-sm btn-outline-secondary",
                                      to: { name: 'EditNoteBLStockPage', params: { id: props.row.id, refNote: props.row.note_stock_ref } }
                                    }, {
                                      default: _withCtx(() => _cache[18] || (_cache[18] = [
                                        _createElementVNode("i", { class: "ph ph-eye me-1" }, null, -1),
                                        _createTextVNode("Voir le détail ", -1)
                                      ])),
                                      _: 2,
                                      __: [18]
                                    }, 1032, ["to"])),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-sm btn-outline-secondary",
                                  onClick: ($event: any) => (_ctx.openPanel(props.row))
                                }, _cache[19] || (_cache[19] = [
                                  _createElementVNode("i", { class: "ph ph-file-text me-1" }, null, -1),
                                  _createTextVNode("Bon de préparation ", -1)
                                ]), 8, _hoisted_22),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-sm btn-outline-secondary",
                                  disabled: !Number(props.row.note_stock_total_parcel) || _ctx.busy === 'labels-' + props.row.id,
                                  onClick: ($event: any) => (_ctx.printLabels(props.row.id))
                                }, [
                                  (_ctx.busy === 'labels-' + props.row.id)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_24))
                                    : (_openBlock(), _createElementBlock("i", _hoisted_25)),
                                  _cache[20] || (_cache[20] = _createTextVNode("Imprimer les étiquettes ", -1))
                                ], 8, _hoisted_23)
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(props.formattedRow[props.column.field]), 1))
              ]),
              _: 1
            }, 8, ["columns", "rows", "loading"]),
            _createVNode(_component_PaginatorContent, {
              pagination: _ctx.filters,
              offset: 9,
              onPaginate: _ctx.getRecords
            }, null, 8, ["pagination", "onPaginate"])
          ])
        ])
      ], 2),
      (_ctx.selected)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", null, [
                    _cache[21] || (_cache[21] = _createElementVNode("h4", { class: "mb-5" }, "Bon de préparation", -1)),
                    _createElementVNode("h5", _hoisted_31, _toDisplayString(_ctx.panel.note?.ref), 1)
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-close",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selected = null))
                  })
                ]),
                (_ctx.panel.note)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("dl", _hoisted_32, [
                        _cache[22] || (_cache[22] = _createElementVNode("dt", { class: "col-5 fw-normal text-muted" }, "Agence", -1)),
                        _createElementVNode("dd", _hoisted_33, _toDisplayString(_ctx.panel.note.agency), 1),
                        _cache[23] || (_cache[23] = _createElementVNode("dt", { class: "col-5 fw-normal text-muted" }, "Date de création", -1)),
                        _createElementVNode("dd", _hoisted_34, _toDisplayString(_ctx.getDate(_ctx.panel.note.created_at)), 1),
                        _cache[24] || (_cache[24] = _createElementVNode("dt", { class: "col-5 fw-normal text-muted" }, "Nombre de colis", -1)),
                        _createElementVNode("dd", _hoisted_35, _toDisplayString(_ctx.panel.note.total), 1),
                        _cache[25] || (_cache[25] = _createElementVNode("dt", { class: "col-5 fw-normal text-muted" }, "Emballés", -1)),
                        _createElementVNode("dd", _hoisted_36, _toDisplayString(_ctx.panel.note.packed) + " / " + _toDisplayString(_ctx.panel.note.total), 1)
                      ]),
                      _createElementVNode("h6", _hoisted_37, "Produits à préparer (" + _toDisplayString(_ctx.panel.products.length) + ")", 1),
                      _createElementVNode("table", _hoisted_38, [
                        _cache[26] || (_cache[26] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "Référence"),
                            _createElementVNode("th", null, "Quantité"),
                            _createElementVNode("th", null, "Emplacement")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.panel.products, (p) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: p.reference + p.location
                            }, [
                              _createElementVNode("td", null, _toDisplayString(p.reference), 1),
                              _createElementVNode("td", null, _toDisplayString(p.qty), 1),
                              _createElementVNode("td", null, _toDisplayString(p.location || "—"), 1)
                            ]))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_39, [
                        _createTextVNode(" Total : " + _toDisplayString(_ctx.panel.products.length) + " références • " + _toDisplayString(_ctx.panel.total_units) + " unités", 1),
                        _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
                        _createTextVNode(" À répartir dans " + _toDisplayString(_ctx.panel.note.total) + " colis ", 1)
                      ]),
                      (_ctx.panel.problems && _ctx.panel.problems.length)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("h6", _hoisted_40, [
                              _cache[28] || (_cache[28] = _createElementVNode("i", { class: "ph ph-warning me-1" }, null, -1)),
                              _createTextVNode("Problèmes signalés (" + _toDisplayString(_ctx.panel.problems.filter((x) => !x.resolved_at).length) + " en cours)", 1)
                            ]),
                            _createElementVNode("ul", _hoisted_41, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.panel.problems, (pr) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: pr.id,
                                  class: _normalizeClass(["border rounded p-2 mb-2", { 'opacity-50': pr.resolved_at }])
                                }, [
                                  _createElementVNode("b", null, _toDisplayString(pr.parcel_code), 1),
                                  _createTextVNode(" — " + _toDisplayString(pr.reason) + " ", 1),
                                  _createElementVNode("div", _hoisted_42, _toDisplayString(pr.reported_by_name) + " · " + _toDisplayString(_ctx.getDate(pr.created_at)), 1),
                                  (!pr.resolved_at)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        class: "btn btn-sm btn-outline-success mt-1",
                                        onClick: ($event: any) => (_ctx.resolveProblem(pr))
                                      }, _cache[29] || (_cache[29] = [
                                        _createElementVNode("i", { class: "ph ph-check me-1" }, null, -1),
                                        _createTextVNode("Marquer comme résolu ", -1)
                                      ]), 8, _hoisted_43))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_44, "Résolu par " + _toDisplayString(pr.resolved_by_name), 1))
                                ], 2))
                              }), 128))
                            ])
                          ], 64))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn pk-btn flex-fill",
                            disabled: !!_ctx.busy,
                            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.printSheet && _ctx.printSheet(...args)))
                          }, [
                            (_ctx.busy === 'print')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_48))
                              : (_openBlock(), _createElementBlock("i", _hoisted_49)),
                            _cache[30] || (_cache[30] = _createTextVNode("Imprimer ", -1))
                          ], 8, _hoisted_47),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-outline-secondary flex-fill",
                            disabled: !!_ctx.busy,
                            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.downloadSheet && _ctx.downloadSheet(...args)))
                          }, [
                            (_ctx.busy === 'download')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_51))
                              : (_openBlock(), _createElementBlock("i", _hoisted_52)),
                            _cache[31] || (_cache[31] = _createTextVNode("Télécharger ", -1))
                          ], 8, _hoisted_50)
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-outline-secondary w-100",
                          disabled: !_ctx.panel.note.total || !!_ctx.busy,
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.printLabels(_ctx.panel.note.id)))
                        }, _cache[32] || (_cache[32] = [
                          _createElementVNode("i", { class: "ph ph-tag me-1" }, null, -1),
                          _createTextVNode("Imprimer les étiquettes ", -1)
                        ]), 8, _hoisted_53)
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}